if ($(".type-detail").length) {







  
  $(".p-thumbnails-wrapper img").each(function () {
    var $img = $(this);
    ["src", "data-src"].forEach(function (attr) {
      var val = $img.attr(attr);
      if (val && val.indexOf("/related/") !== -1) {
        $img.attr(attr, val.replace("/related/", "/big/"));
      }
    });
  });

  $(".btn.btn-lg.btn-conversion.add-to-cart-button").text(translation('dokosiku'));
  $(".p-info-wrapper").append($(".p-detail-inner-header").clone());

  if ($("#p-detail-tabs a[href='#productVideos']").length) {
    $("#p-detail-tabs a[href='#productVideos']").text(translation('souvisejicividea'));
  }
  if ($("#otherInformation").length) {
    $(".description-inner").append($("#otherInformation table").clone());
  }
  if (!$(".p-info-wrapper .flags.flags-default").length) {
    $(".p-info-wrapper").append($(".flags.flags-default").clone());
  }
  $(".p-info-wrapper").append('<div class="customCart"></div>');
  $(".customCart").append($(".p-final-price-wrapper"));
  $(".customCart").append($(".add-to-cart"));
  $(".extended-description h3").text(translation('parametry'));



  if ($(".products-related").length) {
  }
  $();
  if ($("#manufacturerDescription").length) {
    var addressLink = null;

    $(".detail-parameters__gpsr tbody tr").each(function () {
      var $rowLabel = $(this).find("th .row-header-label");
      var rowLabel = $rowLabel.clone().children().remove().end().text().trim().toLowerCase();

      if (rowLabel === "výrobní společnost") {
        $rowLabel.contents().first()[0].textContent = "Výrobce ";
      }

      if (rowLabel === "adresa") {
        var rawAddress = $(this).find("td").first().text().trim();
        if (rawAddress) {
          addressLink = /^https?:\/\//i.test(rawAddress) ? rawAddress : "https://" + rawAddress;
        }
      }
    });

    if (addressLink) {
      var $manufacturerLink = $('<a href="' + addressLink + '" target="_blank" rel="noopener noreferrer"></a>');
      $manufacturerLink.appendTo(".p-detail-inner-header");
      $("#manufacturerDescription img").clone().appendTo($manufacturerLink);
    }
  }
}
